import { selectGameInfoError } from 'modules/overlay-v2/store/game-info/selectors';
import { selectIsMatchAvailable, selectIsMatchDataReady } from 'modules/overlay-v2/store/overlay/selectors';
import useInitOverlayV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-overlay-v2';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useFetchAvailableFeature } from 'shared/hooks/fetchering/use-fetch-available-feature';
import { useAppSelector } from 'store/hooks';
import { UDText } from 'ud-ui/components';
import supabase from '../../../core/supabase/supabase';

import { CanvasEventBoards } from '../components/canvas/canvas-event-boards';
import { CanvasStaticBoards } from '../components/canvas/canvas-static-boards';
import Joystick from '../components/joystick/joystick';
import OverlayConnectionIndicator from '../components/overlay-connection-indicator/overlay-connection-indicator';

function OverlayV2() {
  useInitOverlayV2();

  const isMatchAvailable = useAppSelector(selectIsMatchAvailable);
  const isMatchDataReady = useAppSelector(selectIsMatchDataReady);

  useEffect(() => {
    window.onerror = function (msg, url, line, col, error) {
      supabase.overlayLogs.createError({
        comment: 'overlay - общий',
        message: error?.stack ?? msg.toString(),
      });
    };
  }, []);

  const { organizerId } = useParams();
  const organizerIdNumber = useMemo(() => (organizerId ? Number(organizerId) : undefined), [organizerId]);
  const gameInfoError = useAppSelector(selectGameInfoError);

  const {
    data: feature,
    isLoading: isFeatureLoading,
    error: featureError,
  } = useFetchAvailableFeature({
    userTournamentId: organizerIdNumber,
  });

  useEffect(() => {
    const rootDiv = document.getElementById('root');
    const body = document.getElementsByTagName('body')[0];
    rootDiv?.setAttribute('style', 'background: unset');
    body?.setAttribute('style', 'background: unset; overflow: hidden');
  }, []);

  if (isMatchAvailable === undefined)
    return (
      <div className={'d-flex items-center justify-center'} style={{ width: '100%', height: '100vh' }}>
        <div className={'d-flex center flex flex-col gap-2 rounded-2xl bg-yellow-300 p-4 text-center'}>
          <UDText isNew type={'title-1'}>
            Поиск запущенных матчей
          </UDText>
          <UDText isNew type={'subtitle-3'}>
            При плохом соединении загрузка может занимать несколько минут
          </UDText>
        </div>
      </div>
    );

  if (!isMatchAvailable)
    return (
      <div className={'d-flex m-2 items-start justify-start'} style={{ width: '100%', height: '100vh' }}>
        <div className={'d-flex center flex-col gap-1 rounded-xl bg-accentJonquil/40 p-2 text-center'}>
          {/* <UDText isNew type={'subtitle-2'}>Ни один матч ещё не начался для этого устройства</UDText> */}
          {/* <UDText isNew type={'label-1'}>Пожалуйста, начните матч в мобильном приложении</UDText> */}
          <UDText isNew type={'subtitle-2'}>
            Ожидание начала матча
          </UDText>
        </div>
      </div>
    );

  if (gameInfoError)
    return (
      <div className={'d-flex items-center justify-center'} style={{ width: '100%', height: '100vh' }}>
        <div className={'d-flex center rounded-2xl bg-Red p-4'}>
          <UDText isNew type={'title-1'}>
            Ошибка при получении информации о матче: {gameInfoError}
          </UDText>
        </div>
      </div>
    );

  if (!isMatchDataReady)
    return (
      <div className={'d-flex items-center justify-center'} style={{ width: '100%', height: '100vh' }}>
        <div className={'d-flex center flex flex-col gap-2 rounded-2xl bg-yellow-300 p-4 text-center'}>
          <UDText isNew type={'title-1'}>
            Загрузка, подождите
          </UDText>
          <UDText isNew type={'subtitle-3'}>
            При плохом соединении загрузка может занимать несколько минут
          </UDText>
        </div>
      </div>
    );

  if (featureError)
    return (
      <div className={'d-flex items-center justify-center'} style={{ width: '100%', height: '100vh' }}>
        <div className={'d-flex center rounded-2xl bg-Red p-4'}>
          <UDText isNew type={'title-1'}>
            Ошибка при получении подписки: {(featureError as Error)?.message}
          </UDText>
        </div>
      </div>
    );

  if (isFeatureLoading)
    return (
      <div className={'d-flex items-center justify-center'} style={{ width: '100%', height: '100vh' }}>
        <div className={'d-flex center flex flex-col gap-2 rounded-2xl bg-yellow-300 p-4 text-center'}>
          <UDText isNew type={'title-1'}>
            Загрузка, подождите
          </UDText>
          <UDText isNew type={'subtitle-3'}>
            При плохом соединении загрузка может занимать несколько минут
          </UDText>
        </div>
      </div>
    );

  if (!feature?.OBS_INTEGRATION) {
    return (
      <div className={'d-flex items-center justify-center'} style={{ width: '100%', height: '100vh' }}>
        <div className={'rounded-2xl bg-Red p-4'}>
          <UDText isNew type={'title-1'}>
            Подписка не активирована
          </UDText>
        </div>
      </div>
    );
  }

  return (
    <div key={'overlay'} className={'d-flex justify-content-end'} style={{ width: '100%', height: '100vh' }}>
      <OverlayConnectionIndicator />
      <div
        className={'d-flex justify-content-end'}
        style={{
          background: 'unset',
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
      >
        <CanvasStaticBoards />
        <CanvasEventBoards />
      </div>
      {feature?.OBS_INTEGRATION && <Joystick key={'FullSizeControlPanel-old'} />}
    </div>
  );
}

export default OverlayV2;
